/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import {
  FileInput,
  FileField,
  TextInput,
  SaveButton,
  required,
  SelectInput,
} from 'react-admin';
import { Form } from 'react-final-form';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Toolbar,
  Box,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import _map from 'lodash/map';

import {
  PREVIEW_ATTACHMENTS_TYPE,
  ASSET_TYPE_PREVIEW_TYPES,
} from '../models/asset';

const styles = () => ({
  toolbar: {
    padding: 0,
  },
});

const validateFile = [required()];
const validateLabel = [required()];

const PreviewDialog = (props) => {
  const handleClose = () => {
    props.close();
  };

  const handleSubmit = (preview) => {
    if (props.record) {
      preview.id = props.record.id;
      preview.index = props.record.index;
    }

    preview.tags = PREVIEW_ATTACHMENTS_TYPE[preview.type].tags;
    preview.url = preview.file.url;

    props.onValidated(preview);
    handleClose();
  };

  const previewTypes = ASSET_TYPE_PREVIEW_TYPES[props.assetType];

  // we add a field name previewType to not have conflict with the type in asset.type
  const record = { ...props.record, previewType: props.record.type };

  return (
    <Dialog
      size="large"
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Add preview</DialogTitle>
      <DialogContent>
        <Form
          onSubmit={handleSubmit}
          initialValues={record}
          render={(formProps) => (
            <form id="preview-quick-create">
              <Box>
                <TextInput
                  label="Preview Label"
                  source="label"
                  validate={validateLabel}
                />
              </Box>

              <Box display="flex">
                <Box>
                  <TextInput label="Position" source="weight" />
                </Box>

                {previewTypes && (
                  <Box ml="0.5em">
                    <SelectInput
                      source="previewType"
                      choices={_map(previewTypes, (type) => ({
                        id: type,
                        name: type,
                      }))}
                    />
                  </Box>
                )}
              </Box>

              <Box>
                <FileInput
                  label="Preview Image"
                  source="file"
                  placeholder={<p>Drop your preview file here</p>}
                  validate={validateFile}
                >
                  <FileField source="url" title="title" target="_blank" />
                </FileInput>
              </Box>

              <Toolbar className={props.classes.toolbar}>
                <Box display="flex" justifyContent="flex-end" width="100%">
                  <Box>
                    <Button size="small" onClick={handleClose}>
                      Cancel
                    </Button>
                  </Box>

                  <Box ml="0.5em">
                    <SaveButton
                      size="small"
                      color="primary"
                      handleSubmitWithRedirect={formProps.handleSubmit}
                      label="Add preview"
                    >
                      Submit
                    </SaveButton>
                  </Box>
                </Box>
              </Toolbar>
            </form>
          )}
        />
      </DialogContent>
    </Dialog>
  );
};

export default withStyles(styles)(PreviewDialog);
